import { render } from "./BetreuungPage.vue?vue&type=template&id=4f02c7a6"
import script from "./BetreuungPage.vue?vue&type=script&lang=js"
export * from "./BetreuungPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__